module.exports = __webpack_public_path__ + "static/media/mobile-desktop-create-campaign.82debbfc.jpg";